export default __webpack_public_path__ + "static/media/HIS_Logo.7f702832.svg";